import { render } from "./AboutMeComponent.vue?vue&type=template&id=49f5a27e&scoped=true"
const script = {}

import "./AboutMeComponent.vue?vue&type=style&index=0&id=49f5a27e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f5a27e"]])

export default __exports__